export default __webpack_public_path__ + "static/sisters-hero-6d05ea4981e91bd241aebdea26f76fc5.jpg";